<button [type]="type()" [disabled]="disabled()" [attr.aria-label]="ariaLabel() || label()" (click)="clicked.emit()"
  class="flex items-center justify-center gap-2 min-w-[100px] px-6 py-2 text-[13px] font-bold rounded-xl transition-all active:scale-95 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary outline-none disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:shadow-none"
  [ngClass]="variant() === 'primary'
    ? 'bg-gradient-primary text-white hover:scale-105 shadow-md'
    : 'border border-slate-400 text-slate-700 hover:bg-slate-50'">
  <ng-content />
  {{ label() }}
</button>